import React, { Component, Suspense } from 'react'
import { HashRouter, Route, Routes } from 'react-router-dom'
import './scss/style.scss'

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Dashboard pages
const About = React.lazy(() => import('./views/dashboard/About'))
const Detail = React.lazy(() => import('./views/dashboard/Detail'))
const SupplierDetail = React.lazy(() => import('./views/dashboard/SupplierDetail'))
const Risks = React.lazy(() => import('./views/dashboard/Risks'))
const RisksNotification = React.lazy(() => import('./views/dashboard/RisksNotification'))
const Calculators = React.lazy(() => import('./views/dashboard/Calculators'))
const RisksNotificationShared = React.lazy(
  () => import('./views/dashboard/RisksNotificationShared'),
)
const Yearlyclosure = React.lazy(() => import('./views/dashboard/Yearlyclosure'))
const Suppliers = React.lazy(() => import('./views/dashboard/Suppliers'))
const SuppliersInno = React.lazy(() => import('./views/dashboard/SuppliersInno'))
const SuppliersInnoList = React.lazy(() => import('./views/dashboard/SuppliersInnoList'))
const SuppliersInnoIdeas = React.lazy(() => import('./views/dashboard/SuppliersInnoIdeas'))
const SuppliersInnoProject = React.lazy(() => import('./views/dashboard/SuppliersInnoProject'))
const SuppliersInnoProjectDescription = React.lazy(
  () => import('./views/dashboard/SuppliersInnoProjectDescription'),
)
const SuppliersInnoProjectStatus = React.lazy(
  () => import('./views/dashboard/SuppliersInnoProjectStatus'),
)
const SuppliersSelection = React.lazy(() => import('./views/dashboard/SuppliersSelection'))
const Finances = React.lazy(() => import('./views/dashboard/Finances'))
const Activerisks = React.lazy(() => import('./views/dashboard/Activerisks'))
const Donerisks = React.lazy(() => import('./views/dashboard/Donerisks'))
const Ignoredrisks = React.lazy(() => import('./views/dashboard/Ignoredrisks'))
const Switchedoffrisks = React.lazy(() => import('./views/dashboard/Switchedoffrisks'))
const Profile = React.lazy(() => import('./views/dashboard/Profile'))
const Settings = React.lazy(() => import('./views/dashboard/Settings'))
const AIAdvices = React.lazy(() => import('./views/dashboard/AIAdvices'))
const Payments = React.lazy(() => import('./views/dashboard/Payments'))
const Cafeteria = React.lazy(() => import('./views/dashboard/Cafeteria'))
const Eshop = React.lazy(() => import('./views/dashboard/Eshop'))
const Addons = React.lazy(() => import('./views/dashboard/Addons'))
const DetailAddons = React.lazy(() => import('./views/dashboard/DetailAddons'))
const BuyingList = React.lazy(() => import('./views/dashboard/BuyingList'))
const Scoreboard = React.lazy(() => import('./views/dashboard/Scoreboard'))
const EshopBought = React.lazy(() => import('./views/dashboard/EshopBought'))
const Inbox = React.lazy(() => import('./views/dashboard/Inbox'))
const Wizard = React.lazy(() => import('./views/dashboard/Wizard'))
const Wizard2 = React.lazy(() => import('./views/dashboard/Wizard2'))
const Wizard3 = React.lazy(() => import('./views/dashboard/Wizard3'))
const Test = React.lazy(() => import('./views/dashboard/Test'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Reminders = React.lazy(() => import('./views/pages/login/Reminders'))
const RemindersExample = React.lazy(() => import('./views/pages/login/RemindersExample'))
const RemindersExample1 = React.lazy(() => import('./views/pages/login/RemindersExample1'))
const RemindersExample2 = React.lazy(() => import('./views/pages/login/RemindersExample2'))
const RemindersDetail = React.lazy(() => import('./views/pages/login/RemindersDetail'))
const Solutions = React.lazy(() => import('./views/pages/login/Solutions'))
const Tools = React.lazy(() => import('./views/pages/login/Tools'))
const ToolsExample = React.lazy(() => import('./views/pages/login/ToolsExample'))
const Solvers = React.lazy(() => import('./views/pages/login/Solvers'))
const Finance = React.lazy(() => import('./views/pages/login/Finance'))
const HomeAI = React.lazy(() => import('./views/pages/login/HomeAI'))
const BusinessAI = React.lazy(() => import('./views/pages/login/BusinessAI'))
const Register = React.lazy(() => import('./views/pages/register/Register'))
const Order = React.lazy(() => import('./views/pages/register/Order'))
const Forgot = React.lazy(() => import('./views/pages/register/Forgot'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))

class App extends Component {
  render() {
    return (
      <HashRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <Suspense fallback={loading}>
          <Routes>
            <Route exact path="/login" name="Login Page" element={<Login />} />
            <Route exact path="/reminders" name="Reminders Page" element={<Reminders />} />
            <Route
              exact
              path="/remindersexample"
              name="Reminders Examples"
              element={<RemindersExample />}
            />
            <Route
              exact
              path="/remindersexample1"
              name="Reminders Examples1"
              element={<RemindersExample1 />}
            />
            <Route
              exact
              path="/remindersexample2"
              name="Reminders Examples2"
              element={<RemindersExample2 />}
            />
            <Route
              exact
              path="/remindersdetail"
              name="Reminders Page"
              element={<RemindersDetail />}
            />
            <Route exact path="/solutions" name="Solutions Page" element={<Solutions />} />
            <Route exact path="/tools" name="Tools Page" element={<Tools />} />
            <Route exact path="/toolsexample" name="Tools Page" element={<ToolsExample />} />
            <Route exact path="/solvers" name="Solvers Page" element={<Solvers />} />
            <Route exact path="/finance" name="Finance Page" element={<Finance />} />
            <Route exact path="/homeai" name="Home AI Page" element={<HomeAI />} />
            <Route exact path="/businessai" name="Business AI Page" element={<BusinessAI />} />
            <Route exact path="/register" name="Register Page" element={<Register />} />
            <Route exact path="/order" name="Order Page" element={<Order />} />
            <Route exact path="/forgot" name="Forgot Page" element={<Forgot />} />
            <Route exact path="/404" name="Page 404" element={<Page404 />} />
            <Route exact path="/500" name="Page 500" element={<Page500 />} />
            <Route exact path="/about" element={<About />} />
            <Route exact path="/calculators" element={<Calculators />} />
            <Route exact path="/detail" element={<Detail />} />
            <Route exact path="/supplierdetail" element={<SupplierDetail />} />
            <Route exact path="/risks" element={<Risks />} />
            <Route exact path="/risksnotification" element={<RisksNotification />} />
            <Route exact path="/risksnotificationshared" element={<RisksNotificationShared />} />
            <Route exact path="/suppliers" element={<Suppliers />} />
            <Route exact path="/suppliersinno" element={<SuppliersInno />} />
            <Route exact path="/suppliersinnolist" element={<SuppliersInnoList />} />
            <Route exact path="/suppliersinnoideas" element={<SuppliersInnoIdeas />} />
            <Route exact path="/suppliersinnoproject" element={<SuppliersInnoProject />} />
            <Route
              exact
              path="/suppliersinnoprojectdescription"
              element={<SuppliersInnoProjectDescription />}
            />
            <Route
              exact
              path="/suppliersinnoprojectstatus"
              element={<SuppliersInnoProjectStatus />}
            />
            <Route exact path="/suppliersselection" element={<SuppliersSelection />} />
            <Route exact path="/finances" element={<Finances />} />
            <Route exact path="/profile" element={<Profile />} />
            <Route exact path="/settings" element={<Settings />} />
            <Route exact path="/aiadvices" element={<AIAdvices />} />
            <Route exact path="/payments" element={<Payments />} />
            <Route exact path="/cafeteria" element={<Cafeteria />} />
            <Route exact path="/eshop" element={<Eshop />} />
            <Route exact path="/addons" element={<Addons />} />
            <Route exact path="/addons/detail" element={<DetailAddons />} />
            <Route exact path="/buyinglist" element={<BuyingList />} />
            <Route exact path="/scoreboard" element={<Scoreboard />} />
            <Route exact path="/eshopbought" element={<EshopBought />} />
            <Route exact path="/inbox" element={<Inbox />} />
            <Route exact path="/wizard" element={<Wizard />} />
            <Route exact path="/wizard2" element={<Wizard2 />} />
            <Route exact path="/wizard3" element={<Wizard3 />} />
            <Route exact path="/activerisks" element={<Activerisks />} />
            <Route exact path="/donerisks" element={<Donerisks />} />
            <Route exact path="/ignoredrisks" element={<Ignoredrisks />} />
            <Route exact path="/switchedoffrisks" element={<Switchedoffrisks />} />
            <Route exact path="/yearlyclosure" element={<Yearlyclosure />} />
            <Route exact path="/test" element={<Test />} />
            <Route path="*" name="Home" element={<DefaultLayout />} />
          </Routes>
        </Suspense>
      </HashRouter>
    )
  }
}

export default App
